import { TextField } from "@mui/material";
import { AutocompleteAuthors } from "@styleguide";
import equal from "fast-deep-equal/react";
import { useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterAuthor = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["authors"]>) => {
  const [localValue, setLocalValue] = useState(value);

  const handleDispatch = () => {
    if (!equal(localValue, value)) {
      dispatch({ type: "authors", payload: localValue });
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <AutocompleteAuthors
      multiple
      value={localValue}
      renderInput={(params) => <TextField {...params} label="Référents" size="small" />}
      onBlur={handleDispatch}
      onChange={(_, value, reason) => {
        setLocalValue(value);
        if (reason === "removeOption") {
          dispatch({ type: "authors", payload: value });
        }
      }}
      permissions={["filters.authors"]}
      limitTags={2}
    />
  );
};
